import {Component, Inject} from '@angular/core';
import {EditionDialogComponent} from "../../../../basic-entity-front/edition-dialog/edition-dialog.component";
import {Cliente} from "../../../../model/personas/cliente.model";
import {
    InternalPropertyMap,
    IRI_PROPERTY,
    TYPE_PROPERTY
} from "../../../../basic-entity-back/basic-entity-interface/mapping-internal";
import {Usuario} from "../../../../model/personas/usuario.model";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {BaseDialogData} from "../../../../basic-entity-front/basic-entity-table/base-dialog-data";
import {ApiModuleFactory} from "../../../../api/api-module-factory.service";
import {InterfaceProviderService} from "../../../../basic-entity-back/services/interface-provider.service";
import {UntypedFormBuilder} from "@angular/forms";
import {ErrorDisplayService} from "../../../../basic-entity-front/services/error-display.service";
import {SimpleDialogService} from "../../../../basic-entity-front/dialog-shell/simple-dialog.service";
import {filter, map, reduce} from "rxjs/operators";
import {Subscription} from "rxjs";
import {ApiService} from "../../../../api/api.service";
import {DescuentoCliente} from "../../../../model/trabajos/descuento-cliente.model";
import {BaseDialog} from "../../../../basic-entity-front/basic-entity-table/base-dialog";
import {NestedBehavior, NestedModelTypeInterface} from "../../../../basic-entity-back/property-type/nested-model-type";
import {PropertyType} from "../../../../basic-entity-back/property-type/property-type";
import {SessionService} from "../../../../session/session.service";
import {DireccionPersona} from "../../../../model/personas/direccion-persona.model";
import {Mandato} from "../../../../model/tesoreria/mandatos/mandato.model";
import {MandatosEditionComponent} from "../../../tesoreria/mandatos-edition/mandatos-edition.component";
import {FilterAndData} from "../../../../api/filter-list";
import {ExactSearchFilter} from "../../../../basic-entity-back/filters/search-filter";
import {FormaPagoCliente} from "../../../../model/tesoreria/formas-pago/forma-pago-cliente.model";
import {ClienteAsociado} from "../../../../model/personas/cliente-asociado.model";
import {AsociadosEditionComponent} from "../asociados-edition/asociados-edition.component";
import {ConversacionesService} from "../../../mensajes/conversaciones.service";
import {AccesoMensajesCliente} from "../../../mensajes/conversaciones.model";
import {gestionaMensajesDeClientes} from "../../../mensajes/acceso-mensajes";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";

@Component({
    selector: 'app-clientes-edition',
    templateUrl: './clientes-edition.component.html',
    styleUrls: ['./clientes-edition.component.scss']
})
export class ClientesEditionComponent extends EditionDialogComponent<Cliente> {
    dataSource: any[];
    columns;
    nombreORazonSocialValidos = true;
    clienteFilter: any[];
    dataSourceAsociados: ClienteAsociado[];
    private _cargaAsociados: Subscription;

    // Propiedades que ClienteAsociado hereda de Persona pero que no corresponden a una clínica: al
    // pasar ClienteAsociado a 'extends Persona' (ver cliente-asociado.model.ts), 'columns' -que sale
    // de TODO mappingModelToApi salvo IRI/TYPE/cliente/direcciones- empezó a arrastrarlas también
    // aquí. 'nombre'/'apellido1'/'apellido2' son de persona física (la clínica usa
    // 'denominacionSocial'); 'fechaCreacion'/'fechaModificacion' y 'nombreCompleto' son de sólo
    // lectura, y 'nombreCompleto' además saldría siempre vacío (se calcula a partir de
    // nombre/apellidos, que aquí nunca se rellenan); 'todosLosTelefonos' es un resumen derivado que
    // duplica la propia pestaña de Teléfonos; 'usuario' abre una pestaña de login para una entidad
    // que por diseño no puede tener uno (ClienteAsociado no se autentica nunca, ver
    // ClienteAsociado.php); 'idioma' no lleva 'nullable: true' en Persona.idioma, así que se volvía
    // obligatorio sin que la API lo necesite para este recurso; 'isEmpresa' no lleva el grupo
    // 'clientes_asociados' en el backend (PersonaSuperclass.php), así que la API lo ignora en
    // silencio. 'cifNif'/'email' SÍ se conservan: son campos propios de la clínica desde la Tarea 8
    // (ya existían, con las mismas propiedades, antes de que ClienteAsociado heredara de Persona) y
    // se muestran en la tabla-resumen de esta misma pantalla.
    private static readonly PROPIEDADES_ASOCIADO_NO_APLICABLES = [
        'nombre', 'apellido1', 'apellido2', 'fechaCreacion', 'fechaModificacion',
        'nombreCompleto', 'todosLosTelefonos', 'usuario', 'idioma', 'isEmpresa'
    ];

    /** Lo que el comercial no edita ni en sus clientes: lo decide CNC. La API también lo ignora. */
    public static readonly CAMPOS_SOLO_CNC = ['comercial', 'activado', 'baja', 'esPadre', 'usuario'];

    public get cliente(): Cliente {
        return this.model as Cliente;
    }

    public get fechaCreacion(): string {
        return this.interfaceProvider
            .interfaceForModel(Cliente).serialiser
            .getValueAsString(this.model, 'fechaCreacion');
    }

    public get fechaModificacion(): string {
        return this.interfaceProvider
            .interfaceForModel(Cliente).serialiser
            .getValueAsString(this.model, 'fechaModificacion');
    }

    constructor(@Inject(MAT_DIALOG_DATA) private data: BaseDialogData<Cliente>, dialogRef: MatDialogRef<EditionDialogComponent<Cliente>>,
                apiFactory: ApiModuleFactory, public interfaceProvider: InterfaceProviderService, fb: UntypedFormBuilder, private _myErrorDisplay: ErrorDisplayService,
                private _simpleDialog: SimpleDialogService, private _api: ApiService, private _dialogService: MatDialog,
                private _sessionService: SessionService, private _conversaciones: ConversacionesService) {
        super(data, dialogRef, apiFactory, interfaceProvider, fb, _myErrorDisplay);
        this.columns = ['metodoFabricacion', 'descuento', 'delete'];

        this._loadDataSourceDescuentos();
        this._loadDataSourceAsociados();

        // En el alta de un comercial el cliente es suyo (lo fija la API). Solo en el alta: antes se
        // ponía en cualquier cliente que abriera, y al guardar se lo quedaba.
        if (this.isNew && _sessionService.esComercial()) {
            this.formGroup.get('comercial').setValue(_sessionService.profile);
        }
        this._ajustarParaComercial();

        this.formGroup.valueChanges.subscribe(res => {
            this.nombreORazonSocialValidos = res.nombre !== '' || res.denominacionSocial !== '';
        });

        const clienteProp = this.interfaceProvider.interfaceForModel(FormaPagoCliente).mappingModelToApi['cliente'];
        this.clienteFilter = [new FilterAndData(ExactSearchFilter, this.data.model, clienteProp)];
    }

    public esComercial(): boolean {
        return this._sessionService.esComercial();
    }

    /**
     * Cliente ajeno (se abre en solo lectura): fuera Facturación, Descuentos y Usuario, que la API
     * no le manda. Cliente propio: todo menos lo que decide CNC. Los asociados no entran en esta
     * versión para el comercial (ver la spec §11).
     */
    _ajustarParaComercial() {
        if (!this._sessionService.esComercial()) {
            return;
        }
        this.tags.delete('Clientes asociados');
        if (this.allFieldsDisabled) {
            ['Facturación', 'Descuentos', 'Usuario'].forEach(tag => this.tags.delete(tag));
            return;
        }
        ClientesEditionComponent.CAMPOS_SOLO_CNC.forEach(campo => this.formGroup.get(campo)?.disable({emitEvent: false}));
    }

    public prop(key: string): InternalPropertyMap | undefined {
        return this.properties.find(p => p.modelKey === key);
    }

    ngOnInit() {
        this.formGroup.get('cuentasBancariasCliente').valueChanges.subscribe(res => {
            if (this.formGroup.dirty) {
                this.save();
            }
        });
        this.formGroup.get('formasPagoDisponibles').valueChanges.subscribe(res => {
            if (this.formGroup.dirty) {
                this.save();
            }
        });
        this._cargarAccesoMensajes();

    }

    /** Casilla «Mensajes activados»: null mientras no se sabe (o si no toca enseñarla). */
    public accesoMensajes: AccesoMensajesCliente | null = null;
    public cambiandoMensajes = false;

    /** Solo un empleado del grupo Mensajes, y en un cliente ya guardado. */
    public get puedeGestionarMensajes(): boolean {
        return !this.isNew && !!this.model?.id && gestionaMensajesDeClientes(this._sessionService);
    }

    private _cargarAccesoMensajes(): void {
        if (!this.puedeGestionarMensajes) {
            return;
        }
        this._conversaciones.accesoCliente(this.model.id).subscribe({
            next: acceso => this.accesoMensajes = acceso,
            error: () => this.accesoMensajes = null
        });
    }

    /** Mete o saca al usuario del cliente del grupo Mensajes. Si falla, la casilla vuelve a como estaba. */
    public cambiarMensajes(evento: MatSlideToggleChange): void {
        this.cambiandoMensajes = true;
        this._conversaciones.cambiarAccesoCliente(this.model.id, evento.checked).subscribe({
            next: acceso => {
                this.accesoMensajes = acceso;
                this.cambiandoMensajes = false;
            },
            error: e => {
                evento.source.checked = !evento.checked;
                this.cambiandoMensajes = false;
                this._myErrorDisplay.displayError(e);
            }
        });
    }

    public puedeCrearAcceso(): boolean {
        return !this.model.usuario && !!this.formGroup.get('email')?.value;
    }

    public crearAcceso() {
        const usuario = new Usuario();
        usuario.username = this.formGroup.get('email').value;
        // Sin contraseña y sin enabled: el backend (UsuarioSubscriber) lo deja pendiente
        // (con activationCode) por ser un Cliente creado por un empleado. El cliente fijará
        // su contraseña con el enlace de la Imagen #2 cuando se active.
        this.model.usuario = usuario;
        this.save();
    }

    public puedeReenviarActivacion(): boolean {
        // Solo si ya está activado (la Imagen #2 ya se envió) y el login sigue pendiente
        // (el cliente aún no ha fijado su contraseña).
        return !!this.model.usuario && !this.model.usuario.enabled && this.model.activado;
    }

    public reenviarActivacion() {
        this._api.put(`${this.model.usuario.iri}/resend_activation`, {})
            .pipe(ApiService.sTakeBody())
            .subscribe(
                () => this._simpleDialog.simpleDialog(
                    'Activación reenviada',
                    'Se ha reenviado el correo de activación al cliente.',
                    [{text: 'Aceptar', value: null}]
                ),
                err => this._myErrorDisplay.displayError(err)
            );
    }

    public activarUsuario() {
        const email = this.formGroup.get('email').value;
        this._simpleDialog.simpleDialog(
            'Confirmar datos',
            `Para activar el usuario, por favor confirma con el cliente que el correo es válido:<br><strong>${email}</strong>`,
            [
                {text: 'Cancelar', color: "accent", value: false},
                {text: 'Confirmar', color: "primary", value: true, icon: 'done'}
            ]
        ).afterClosed().pipe(filter(v => v)).subscribe(() => {
            const serialiser = this.interfaceProvider.interfaceForModel(Usuario).serialiser;
            this._api
                .put(`${this.model.usuario.iri}/force_activation`, {})
                .pipe(
                    ApiService.sTakeBody(),
                    map(obj => serialiser.fromApi(obj))
                )
                .subscribe((receivedUser) => {
                        serialiser.copyInto(this.model.usuario, receivedUser);
                        this.formManager.setValue(this.prop('usuario'), this.model.usuario);
                    },
                    err => this._myErrorDisplay.displayError(err),
                );
        });
    }

    public borrarUsuario() {
        this.formGroup.get('usuario').setValue(null);
    }

    _loadDataSourceDescuentos() {
        if (this.cliente.isTemporalEntity) {
            return;
        }
        this.interfaceProvider.managerForModel(Cliente).loader.findById(this.cliente.id).subscribe(cliente => {
            this.dataSource = cliente.descuentosMetodoFabricacion
        });
    }

    anadirItem() {
        const manager = this.interfaceProvider.managerForModel(DescuentoCliente);
        const intrf = manager.loader.entityInterface;
        const newDescuento = intrf.serialiser.getEmptyModel();
        newDescuento.cliente = this.model.iri;
        const ref = this._dialogService.open<BaseDialog<DescuentoCliente>, BaseDialogData<DescuentoCliente>, any>(EditionDialogComponent, {
            disableClose: true,
            autoFocus: true,
            restoreFocus: true,
            data: {
                model: newDescuento,
                allowIdEdition: !intrf.autogeneratedId,
                columns: Object.values(intrf.mappingModelToApi).filter(p => ![IRI_PROPERTY, TYPE_PROPERTY, 'cliente'].includes(p.modelKey)),
                showSaveAndCancelButtons: !intrf.readonlyInterface,
                isNew: true,
                shouldManageSaving: true
            }
        });
        ref.afterClosed().subscribe(result => {
            if (result) {
                this._loadDataSourceDescuentos();
            }
        });
    }


    editarItem(item) {
        const transferIntf = this.interfaceProvider.interfaceForModel(DescuentoCliente);
        const fakeType: NestedModelTypeInterface<DescuentoCliente> =
            PropertyType.NestedModel(DescuentoCliente, 'cliente', NestedBehavior.CreateOnly, [IRI_PROPERTY, TYPE_PROPERTY, 'cliente']).asNestedModel();
        const dialog = this._dialogService.open(
            EditionDialogComponent,
            {
                data: fakeType.baseDialogDataForModel(
                    transferIntf,
                    item,
                    false,
                    true,
                    false
                )
            }
        );
        dialog.afterClosed().subscribe(result => {
            if (result === BaseDialog.RESULT_SHOULD_RELOAD) {
                this._loadDataSourceDescuentos();
            }
        });
    }

    eliminarItem(element) {
        this._simpleDialog
            .confirmationDialog(
                'Eliminar',
                `¿Seguro que deseas eliminar el registro?`,
                ['Eliminar', 'delete_forever', 'warn']
            )
            .then(del => {
                if (del) {
                    this.interfaceProvider.managerForModel(DescuentoCliente).remove(element).subscribe(res => {
                        this._loadDataSourceDescuentos();
                    });
                }
            });
    }

    _loadDataSourceAsociados() {
        if (this.cliente.isTemporalEntity) {
            return;
        }
        // No se lee de cliente.clientesAsociados: al venir incrustado en la respuesta de /clientes
        // usa el grupo de normalización de Cliente, que no incluye denominacionSocial ni baja del
        // asociado (sólo están en su propio grupo clientes_asociados_out). Se pide la colección
        // directamente para que traiga el asociado completo.
        //
        // `findAndFollow`, no `find`: `find` sólo trae la primera página (30 por defecto) y un cliente
        // con más clínicas perdía las demás. `findAndFollow` emite una vez por página, así que se
        // juntan todas antes de pintar. Se recarga tras añadir/editar una clínica: la carga anterior
        // se cancela para que, si llega tarde, no pise a la nueva.
        const clienteProp = this.interfaceProvider.interfaceForModel(ClienteAsociado).mappingModelToApi['cliente'];
        const filtros = [new FilterAndData(ExactSearchFilter, this.model, clienteProp)];
        this._cargaAsociados?.unsubscribe();
        this._cargaAsociados = this.interfaceProvider.managerForModel(ClienteAsociado).loader.findAndFollow(filtros).pipe(
            reduce((asociados: ClienteAsociado[], pagina) => asociados.concat(pagina.member), [])
        ).subscribe(asociados => {
            this.dataSourceAsociados = asociados;
        });
    }

    anadirAsociado() {
        const manager = this.interfaceProvider.managerForModel(ClienteAsociado);
        const intrf = manager.loader.entityInterface;
        const newAsociado = intrf.serialiser.getEmptyModel();
        newAsociado.cliente = this.model.iri;
        const ref = this._dialogService.open<BaseDialog<ClienteAsociado>, BaseDialogData<ClienteAsociado>, any>(AsociadosEditionComponent, {
            disableClose: true,
            autoFocus: true,
            restoreFocus: true,
            data: {
                model: newAsociado,
                allowIdEdition: !intrf.autogeneratedId,
                // 'direcciones' se excluye también aquí (no sólo sin tag en el modelo): las
                // 'columns' del diálogo salen de todo mappingModelToApi, así que estar sin tag no
                // basta para que no aparezca como campo suelto. Lo que se edita es
                // 'direccionesVigentes' (ver cliente-asociado.model.ts). Ídem con
                // PROPIEDADES_ASOCIADO_NO_APLICABLES (ver su comentario, junto a la declaración).
                columns: Object.values(intrf.mappingModelToApi).filter(p => ![IRI_PROPERTY, TYPE_PROPERTY, 'cliente', 'direcciones', ...ClientesEditionComponent.PROPIEDADES_ASOCIADO_NO_APLICABLES].includes(p.modelKey)),
                showSaveAndCancelButtons: !intrf.readonlyInterface,
                isNew: true,
                shouldManageSaving: true
            }
        });
        ref.afterClosed().subscribe(result => {
            if (result === BaseDialog.RESULT_SHOULD_RELOAD) {
                this._loadDataSourceAsociados();
            }
        });
    }

    editarAsociado(item: ClienteAsociado) {
        const transferIntf = this.interfaceProvider.interfaceForModel(ClienteAsociado);
        // Mismo motivo que en anadirAsociado(): 'direcciones' fuera de las 'columns', el formulario
        // sólo trabaja con 'direccionesVigentes'; y misma lista PROPIEDADES_ASOCIADO_NO_APLICABLES.
        const fakeType: NestedModelTypeInterface<ClienteAsociado> =
            PropertyType.NestedModel(ClienteAsociado, 'cliente', NestedBehavior.CreateOnly, [IRI_PROPERTY, TYPE_PROPERTY, 'cliente', 'direcciones', ...ClientesEditionComponent.PROPIEDADES_ASOCIADO_NO_APLICABLES]).asNestedModel();
        const dialog = this._dialogService.open(
            AsociadosEditionComponent,
            {
                data: fakeType.baseDialogDataForModel(
                    transferIntf,
                    item,
                    false,
                    true,
                    false
                )
            }
        );
        dialog.afterClosed().subscribe(result => {
            if (result === BaseDialog.RESULT_SHOULD_RELOAD) {
                this._loadDataSourceAsociados();
            }
        });
    }

    /**
     * Sólo la casilla del permiso. La pestaña de clientes asociados pinta su tabla a mano, sin el
     * bloque genérico de campos, así que hay que darle explícitamente lo que sí debe renderizar;
     * `colsForTag` devolvería también la propia colección de asociados, que no es un campo de
     * formulario.
     */
    colsPermisoAsociados() {
        return this.colsForTag('Clientes asociados').filter(col => col.modelKey === 'esPadre');
    }

    /**
     * Rellena la dirección que falta con la otra: la de facturación con la (primera) de envío, o
     * una de envío con la de facturación. Con las dos puestas no hace nada (el botón no sale).
     */
    direccionesIguales() {
        const dirFact = this.formGroup.get('direccionFacturacion');
        const envios = this._direccionesEnvioDelFormulario();
        if (!dirFact.value && envios.length) {
            dirFact.setValue(this._copiaDireccion(envios[0]));
        } else if (dirFact.value && !envios.length) {
            this.formManager.addToFormArray('direccionesEnvio', this._copiaDireccion(dirFact.value));
        }
    }

    mostrarBotonDireccionesIguales() {
        const hayFacturacion = !!this.formGroup.get('direccionFacturacion').value;
        const hayEnvio = this._direccionesEnvioDelFormulario().length > 0;
        return hayFacturacion !== hayEnvio;
    }

    private _direccionesEnvioDelFormulario(): DireccionPersona[] {
        return this.formManager.getValue(this.prop('direccionesEnvio')).filter(d => !!d);
    }

    private _copiaDireccion(origen: DireccionPersona): DireccionPersona {
        const copia = new DireccionPersona();
        copia.calle = origen.calle;
        copia.demarcacion = origen.demarcacion;
        copia.poblacion = origen.poblacion;
        copia.cp = origen.cp;
        copia.pais = origen.pais;
        return copia;
    }

    generarMandato() {
        if (!this.data.model.mandato || this.data.model.mandato.isTemporalEntity) {
            const manager = this.interfaceProvider.managerForModel(Mandato);
            const intrf = manager.loader.entityInterface;
            const newMandato = intrf.serialiser.getEmptyModel();
            newMandato.cliente = this.model.iri;
            const ref = this._dialogService.open<BaseDialog<Mandato>, BaseDialogData<Mandato>, any>(MandatosEditionComponent, {
                disableClose: true,
                autoFocus: true,
                restoreFocus: true,
                data: {
                    model: newMandato,
                    allowIdEdition: !intrf.autogeneratedId,
                    columns: Object.values(intrf.mappingModelToApi).filter(p => ![IRI_PROPERTY, TYPE_PROPERTY, 'cliente'].includes(p.modelKey)),
                    showSaveAndCancelButtons: !intrf.readonlyInterface,
                    isNew: true,
                    shouldManageSaving: true
                },
                width: '800px'
            });
            ref.afterClosed().subscribe(result => {
                if (result) {
                    console.log(newMandato)
                    this.model.mandato = newMandato;
                }
            });
        } else {
            const transferIntf = this.interfaceProvider.interfaceForModel(Mandato);
            const fakeType: NestedModelTypeInterface<Mandato> =
                PropertyType.NestedModel(Mandato, 'cliente', NestedBehavior.CreateOnly, [IRI_PROPERTY, TYPE_PROPERTY, 'cliente']).asNestedModel();
            this.data.model.mandato.cliente = this.model.iri;
            const dialog = this._dialogService.open(
                MandatosEditionComponent,
                {
                    data: fakeType.baseDialogDataForModel(
                        transferIntf,
                        this.data.model.mandato,
                        false,
                        true,
                        false
                    )
                }
            );
            dialog.afterClosed().subscribe(result => {

                console.log(result)
            });
        }
    }
}
